import { type FunctionComponent, type ReactNode } from 'react'
import { useFastFind } from '../utils/hooks/useFastFind'
import FastFindModal from './FastFindModal'

const FastFindProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const { isOpen, closeModal, navigateToSearch } = useFastFind()
  return (
    <>
      {children}
      <FastFindModal isOpen={isOpen} onClose={closeModal} onSearch={navigateToSearch} />
    </>
  )
}

export default FastFindProvider
